import { useFeature as flaggedUseFeature } from 'flagged';

import type { FeatureName, Features } from './features';

export function useFeature<Key extends FeatureName>(name: Key) {
  return flaggedUseFeature(name) as Features[Key];
}
